export default __webpack_public_path__ + "static/media/medium.72e8be96.svg";